/**
 * @file The ReassignDetailComponent is used as detail view for the inbox and outbox to display reassign requests.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DomainService } from '../../domain.service';
import { UserService } from '../../user.service';
import { AlertsService } from '../../core/alerts.service';
import { DialogService } from '../../core/dialog.service';
import { NotificationsService } from '../notifications.service';
import { ExchangeDetailComponent } from '../exchange-detail/exchange-detail.component';
import { SettingsService } from '../../settings.service';
/**
 * The ReassignDetailComponent is used as detail view for the inbox and outbox to display reassign requests.
 * @export
 * @class ReassignDetailComponent
 * @extends {ExchangeDetailComponent}
 * @implements {OnDestroy}
 */
var ReassignDetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ReassignDetailComponent, _super);
    /**
     * Creates an instance of ReassignDetailComponent.
     * @param {configurationsService} configurationsService Service to get the configuration for this component.
     * @param {Router} router The angular router enabling navigation between the different form modes.
     * @param {ActivatedRoute} route The active route.
     * @param {NotificationsService} notificationsService The notifications service to handle request entities.
     * @param {DialogService} dialogService The dialog service.
     * @param {AlertsService} alertsService The alert service.
     * @param {DomainService} domainService The domain service to handle planned entities.
     */
    function ReassignDetailComponent(userService, router, route, notificationsService, dialogService, alertsService, domainService, settingsService, translateService) {
        var _this = _super.call(this, userService, router, route, notificationsService, dialogService, alertsService, settingsService, translateService) || this;
        _this.domainService = domainService;
        /**
         * Gets, sets the proposal task. The proposal is a copy of the subject task where the resource is changed to the receiver.
         * The created proposal task is for display only. The proposal is not saved.
         * @type {Entity}
         * @memberOf ReassignDetailComponent
         */
        _this.proposal = null;
        return _this;
    }
    Object.defineProperty(ReassignDetailComponent.prototype, "targetOid", {
        /**
         * Gets the oid of the target reassign request task.
         * This is for display only. The oid equals with the oid of the temporary created proposal.
         * @readonly
         * @memberOf ReassignDetailComponent
         */
        get: function () {
            if (!this.proposal) {
                return null;
            }
            return this.proposal['Oid'];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is invoked after the request of the detail is retrieved.
     * The method gathers the planned items of the request from the domainService.
     * @protected
     * @memberOf ReassignDetailComponent
     */
    ReassignDetailComponent.prototype.afterRequestRetrieved = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var subjectType, subject, resourceOid, dummy, resourceType, resource;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.proposal) {
                            this.proposal.entityAspect.setDetached();
                            this.proposal = null;
                        }
                        if (!!this.request.SubjectDay) return [3 /*break*/, 4];
                        subjectType = this.domainService.getEntityType(this.request.SubjectType);
                        return [4 /*yield*/, this.domainService.getEntityByKey(subjectType, this.request.SubjectOid, true).toPromise()];
                    case 1:
                        subject = _a.sent();
                        if (!subject) {
                            this.targetFormObject.item = null;
                            this.targetFormObject.isLoading = false;
                            return [2 /*return*/];
                        }
                        resourceOid = subject['Resource_Oid'];
                        subject['Resource_Oid'] = null;
                        dummy = this.domainService.copy(subject);
                        subject['Resource_Oid'] = resourceOid;
                        subject.entityAspect.setUnchanged();
                        dummy['Resource'] = null;
                        dummy['Resource_Oid'] = this.request.ReceiverOid;
                        if (!(dummy['Resource'] === null)) return [3 /*break*/, 3];
                        resourceType = this.domainService.getEntityType('Resource');
                        return [4 /*yield*/, this.domainService.getEntityByKey(resourceType, this.request.ReceiverOid, true).toPromise()];
                    case 2:
                        resource = _a.sent();
                        dummy['Resource'] = resource;
                        _a.label = 3;
                    case 3:
                        dummy.entityAspect.setUnchanged();
                        this.proposal = dummy;
                        _a.label = 4;
                    case 4:
                        this.checkIsRead();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns a value indicating whether the reassignment can be saved.
     * @memberOf ReassignDetailComponent
     */
    ReassignDetailComponent.prototype.canSave = function () {
        return this.request != null && this.subjectFormObject && this.subjectFormObject.item != null;
    };
    /**
     * Lifecycle hook that is called when the ReassignDetailComponent is destroyed.
     * The method detached the temporary created proposal to avoid that it is commited to the database.
     * @memberOf ReassignDetailComponent
     */
    ReassignDetailComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.proposal) {
            this.proposal.entityAspect.setDetached();
        }
    };
    return ReassignDetailComponent;
}(ExchangeDetailComponent));
export { ReassignDetailComponent };
